import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "./client";
import type { LogoutResponse, Me } from "./types";

export const ME_KEY = ["me"] as const;

/** The signed-in user and their balance. Polled every 30 s so the chip follows
 *  `credits.*` events without a socket (docs/08 §1). */
export function useMe() {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: () => api<Me>("/v1/me"),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}

/** Ends the local session; the caller then navigates to `end_session_url` so
 *  Accounts ends its session too. */
export function useLogout() {
  return useMutation({
    mutationFn: () => api<LogoutResponse>("/api/logout", { method: "POST" }),
  });
}
